import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsInt, IsOptional, Min } from 'class-validator';
import { LoyaltyProgramExposeGroupEnum } from '../interface';
export class CreateLoyaltyPromotionConditionsDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'Maximum number of usages of that loyalty discount can be applied in the cart ', default: 1 }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsOptional({ always: true }),
    IsInt({ always: true }),
    Min(0, { always: true }),
    __metadata("design:type", Number)
], CreateLoyaltyPromotionConditionsDto.prototype, "maxUsagesPerCart", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'should paid modifiers be discounted', example: true }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], CreateLoyaltyPromotionConditionsDto.prototype, "appliesToModifiers", void 0);
//# sourceMappingURL=CreateLoyaltyPromotionConditionsDto.js.map